module.exports = __webpack_public_path__ + "product/product-step@2x-b1cbc2e3719ed0baea3a66db955c4ec3.png";